// @ts-ignore
import buildLocalizeFn from "date-fns/locale/_lib/buildLocalizeFn";

const eraValues = {
	narrow: ["v.Chr.", "n.Chr."] as const,
	abbreviated: ["v.Chr.", "n.Chr."] as const,
	wide: ["vor Christus", "nach Christus"] as const,
};

const quarterValues = {
	narrow: ["1", "2", "3", "4"] as const,
	abbreviated: ["Q1", "Q2", "Q3", "Q4"] as const,
	wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"] as const,
};
type Localize = any;
type LocalizeFn<T> = (arg: T) => any;

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
	narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"] as const,
	abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"] as const,
	wide: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
	] as const,
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const formattingMonthValues = {
	narrow: monthValues.narrow,
	abbreviated: [
		"Jan.",
		"Feb.",
		"März",
		"Apr.",
		"Mai",
		"Juni",
		"Juli",
		"Aug.",
		"Sep.",
		"Okt.",
		"Nov.",
		"Dez.",
	] as const,
	wide: monthValues.wide,
};

const dayValues = {
	narrow: ["S", "M", "D", "M", "D", "F", "S"] as const,
	short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"] as const,
	abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."] as const,
	wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"] as const,
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const dayPeriodValues = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachm.",
		evening: "Abend",
		night: "Nacht",
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachmittag",
		evening: "Abend",
		night: "Nacht",
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachmittag",
		evening: "Abend",
		night: "Nacht",
	},
};
const formattingDayPeriodValues = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachm.",
		evening: "abends",
		night: "nachts",
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachmittags",
		evening: "abends",
		night: "nachts",
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachmittags",
		evening: "abends",
		night: "nachts",
	},
};

const ordinalNumber: LocalizeFn<number> = (dirtyNumber) => {
	const number = Number(dirtyNumber);

	return number + ".";
};

export const localize: Localize = {
	ordinalNumber,

	era: buildLocalizeFn({
		values: eraValues,
		defaultWidth: "wide",
	}),

	quarter: buildLocalizeFn({
		values: quarterValues,
		defaultWidth: "wide",
		argumentCallback: (quarter: number) => quarter - 1,
	}),

	month: buildLocalizeFn({
		values: monthValues,
		formattingValues: formattingMonthValues,
		defaultWidth: "wide",
	}),

	day: buildLocalizeFn({
		values: dayValues,
		defaultWidth: "wide",
	}),

	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues,
		defaultFormattingWidth: "wide",
	}),
};
